import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/element-theme/index.css'
import '@/assets/theme.less'
import '@/assets/global.less'
import '@/assets/iconfont/iconfont.css'

import '@/pages/publicUtils/filter'
import './utils/permission'

import PublicSearch from '@/pages/page1/components/publicSearch.vue'
import PublicFooter from '@/pages/page1/components/publicFooter.vue'
import PublicHeader from '@/pages/page1/components/publicHeader.vue'
import PublicMenu from '@/pages/page1/components/publicMenu.vue'

import VueLazyload from 'vue-lazyload'
import VuePhotoZoomPro from "vue-photo-zoom-pro";
import VueCookies from 'vue-cookies'
import MetaInfo from 'vue-meta-info';

// 全局变量 在indexhtml通过script加载
Vue.prototype.$configId = process.env.VUE_APP_BASE_JS === "dev_js" ? configDevId : configProId;

Vue.use(ElementUI);
Vue.use(VuePhotoZoomPro)
Vue.use(VueCookies)
Vue.use(MetaInfo)
// 有效期设为0 session模式存储 关闭【浏览器】才删除
VueCookies.config('0')
Vue.use(VueLazyload, { //若不存在会error  先判断是否存在
  preLoad: 1.3,
  error: require('@/assets/img/error-goods.jpg'), //加载失败图片
  attempt: 3
})


Vue.component('PublicSearch', PublicSearch)
Vue.component('PublicFooter', PublicFooter)
Vue.component('PublicHeader', PublicHeader)
Vue.component('PublicMenu', PublicMenu)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event')) ///* 这句非常重要，否则预渲染将不会启动 */
  }
}).$mount('#app')